import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { setThrowInvalidWriteToSignalError } from '@angular/core/primitives/signals';

@Component({
    selector: 'app-sso-page',
    imports: [],
    templateUrl: './sso-page.component.html',
    styleUrl: './sso-page.component.scss'
})
export class SsoPageComponent implements OnInit{

  constructor(private authService: AuthService){}

  ngOnInit(): void {
    this.authService.loginWithKeycloak();
  }

}
